export type ContextPropWaiter = {
  promise: Promise<any>;
  resolve: typeof Promise.resolve;
};

export type ContextAvailability = {
  all: Promise<any[]>;
  props: {
    [key: string]: ContextPropWaiter;
  };
};

export function makeContextAvailability(keys: string[]): ContextAvailability {
  const obj: any = {
    props: {},
  };
  keys.forEach(key => {
    obj.props[key] = {};
    obj.props[key].promise = new Promise(resolve => {
      obj.props[key].resolve = resolve;
    });
  });
  obj.all = Promise.all(keys.map(key => obj.props[key].promise));
  return obj;
}
